import { DeliveryMode, OrderMethod } from '../../../../../../../services/exports/Constants';

export default {
  title: '¿El pedido tardará más o menos?',
  text: {
    [OrderMethod.Pickup]:
      'El cliente espera recoger el pedido el <strong>{{date}}</strong> a las <strong>{{time}}</strong><br/> Si es necesario, puedes cambiar la hora aquí.',
    [OrderMethod.OnSite]:
      'El cliente espera el pedido en <strong>{{table}}</strong><br/><strong>{{date}}</strong> a las <strong>{{time}}</strong><br/> Si es necesario, puedes cambiar la hora aquí.',
    // A table order whose table the backend could not name.
    on_site_without_table:
      'El cliente espera el pedido en su mesa el <strong>{{date}}</strong> a las <strong>{{time}}</strong><br/> Si es necesario, puedes cambiar la hora aquí.',
    [OrderMethod.Delivery]: {
      [DeliveryMode.Internal]:
        'El cliente espera recibir el pedido el <strong>{{date}}</strong> a las <strong>{{time}}</strong><br/> Si es necesario, puedes cambiar la hora aquí.',
      [DeliveryMode.External]:
        'El conductor llegará a recoger el pedido a las <strong>{{time}}{{confidenceLabel}}</strong>',
    },
  },
  labels: {
    today: 'Hoy',
  },
  confidence_labels: {
    estimated: ' (¡estimado!)',
    confirmed: '',
  },
  buttons: {
    confirm_pickup: 'Confirmar nueva hora de recogida',
    confirm_on_site: 'Confirmar nueva hora de servicio',
    confirm_delivery: 'Confirmar nueva hora de entrega',
  },
  confirmation_modal: {
    description: '¿Seguro que quieres cambiar la hora de {{currentPickupTime}} a {{newPickupTime}}?',
    ok_button_text: 'Confirmar nueva hora',
    cancel_button_text: 'No, volver a la hora original',
  },
};
